import React, { Fragment, useContext } from 'react'
import { Card, Grid, List, ListItem, Message, Button } from 'semantic-ui-react'
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from '../../../App/stores/RootStore'
import { IAdminDocument } from '../../../App/models/AdminDocument';
import DocumentForm from './Form/DocumentForm';
import DocumentQuestionForm from './DocumentQuestions/DocumentQuestionForm';

const DocumentList: React.FC = () => {
    const rootStore = useContext(RootStoreContext)
    const { AdminDocumentsByOrder } = rootStore.adminDocumentStore;
    const { openModal } = rootStore.modalStore;

    return (
        <Fragment>
            <Button
                className={'rl-btn'}
                onClick={() => openModal(<DocumentForm document={undefined} />)}
                icon='plus'
                content="Create Document"
            />
            <Grid columns={3} divided style={{ overflowY: "auto" }}>
                {AdminDocumentsByOrder.map((adminDocument: IAdminDocument) => (
                    <Grid.Column width={8} key={adminDocument.id}>
                        <Card.Group>
                            <Card fluid>
                                <Card.Content>
                                    <Card.Header>
                                        {adminDocument.type}
                                    </Card.Header>
                                    <Card.Meta>
                                        <List>
                                            <ListItem>Id: {adminDocument.id}</ListItem>
                                            <ListItem>Order: {adminDocument.order.toString()}</ListItem>
                                            <ListItem>Limit per review: {adminDocument.limit.toString()}</ListItem>
                                            <ListItem>Document required: {adminDocument.required.toString()}</ListItem>
                                            <ListItem>Note Required: {adminDocument.noteRequired.toString()}</ListItem>
                                            <ListItem>Can Fail a Review: {adminDocument.canFailReview.toString()}</ListItem>
                                            <Button
                                                className={'rl-btn'}
                                                onClick={() => openModal(<DocumentForm document={adminDocument} />)}
                                                icon='edit'
                                                content="Edit"
                                            />
                                            <Button
                                                className={'rl-btn'}
                                                onClick={() => openModal(<DocumentQuestionForm document={adminDocument} />, "small")}
                                                icon='group'
                                                content="Edit Relationship"
                                            />
                                        </List>
                                    </Card.Meta>
                                    <Card.Description>
                                        <Message content={adminDocument.description} />
                                    </Card.Description>
                                </Card.Content>
                            </Card>
                        </Card.Group>
                    </Grid.Column>
                ))}
            </Grid>
        </Fragment>
    )
}
export default observer(DocumentList);